const PUNCTUATION_RE = /([.!?;。？！])/gu;

export function text2HTML(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function html2Text(html: string): string {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent ?? '';
}

export function getTextByteLength(text: string): number {
  let len = 0;
  for (let i = 0; i < text.length; i++) {
    len += text.charCodeAt(i) > 0x7f ? 2 : 1;
  }
  return len;
}

export function splitTextByPunctuation(text: string): string[] {
  const parts = text.split(PUNCTUATION_RE);

  const result: string[] = [];
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (PUNCTUATION_RE.test(part)) {
      PUNCTUATION_RE.lastIndex = 0;
      if (result.length > 0) {
        result[result.length - 1] += part;
      } else {
        result.push(part);
      }
    } else if (part.length > 0) {
      result.push(part);
    }
  }

  return result;
}

export function splitLongText(text: string, maxLen: number): string[] {
  if (text.length <= maxLen) return [text];

  const sentences = splitTextByPunctuation(text);
  const chunks: string[] = [];

  for (const sentence of sentences) {
    if (sentence.length <= maxLen) {
      chunks.push(sentence);
      continue;
    }

    const words = sentence.split(/\s+/);
    let current = '';

    for (const word of words) {
      if (current.length + word.length + 1 > maxLen && current.length > 0) {
        chunks.push(current);
        current = '';
      }

      if (word.length > maxLen) {
        if (current.length > 0) {
          chunks.push(current);
          current = '';
        }
        const re = new RegExp(`.{1,${maxLen}}`, 'g');
        const parts = word.match(re) ?? [word];
        chunks.push(...parts);
      } else {
        current = current.length > 0 ? `${current} ${word}` : word;
      }
    }

    if (current.length > 0) chunks.push(current);
  }

  return chunks;
}
